import React, { Component } from "react";
import "../styles/App.scss";
import firebase from "firebase";
import Nav from "../components/Nav";
import Sidebar from "../components/Sidebar";
import reservedImage from "../images/reserved.png";
import occupiedImage from "../images/occupied.png";
import hauLogo from "../images/hau.png";
import ConfirmationModal from "../components/confirmationModal";
import Footer from "../components/Footer";
import "../styles/parkingStatus.css";
import LoadingPage from "../components/LoadingPage";

// redux
import { connect } from "react-redux";

class Home extends Component {
  state = {
    allParkingSlots: [],
    show: false,
    parkingToReserve: "",
    loading: true
  };

  componentDidMount() {
    const db = firebase.firestore();

    db.collection("parking_status").onSnapshot(snapshot => {
      let parkingMarkUp = [];
      snapshot.forEach(data => {
        parkingMarkUp.push(data.data());
      });
      this.setState({ allParkingSlots: parkingMarkUp, loading: false });
    });
  }

  handleClose = () => {
    this.setState({
      show: false,
      parkingToReserve: ""
    });
  };

  handleOpenModal = parkingId => {
    this.setState({
      show: true,
      parkingToReserve: parkingId
    });
  };

  render() {
    let { allParkingSlots } = this.state;
    const { user } = this.props;
    const divClassname =
      user.role === "admin"
        ? "col-md-9 col-lg-10 pl-3 p-0 mt-5"
        : "col-md-8 col-lg-12 p-0 mt-5";
    return (
      <div>
        {this.state.loading ? (
          <LoadingPage />
        ) : (
          <div>
            <Nav />
            <div className="row content-div mr-0">
              {user.role === "admin" && (
                <div class="col-md-2 d-md-block sidebar">
                  <Sidebar />
                </div>
              )}
              <div className={divClassname}>
                <ConfirmationModal
                  show={this.state.show}
                  handleClose={this.handleClose}
                  parkingToReserve={this.state.parkingToReserve}
                />
                <div className="container shadow mb-5 bg-white rounded parking-status-container">
                  <div className="row justify-content-center">
                    <div className="col-md-9 col-lg-12 border border-dark text-center hauDiv">
                      <div>
                        <img src={hauLogo} alt="" />
                        <h6>
                          HOLY ANGEL <br />
                          UNIVERSITY
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-md-1 d-md-block gym-2 loc-label">
                      <h6>GYM-2</h6>
                    </div>
                    <div className="col-md col-lg-11 p-0">
                      <div className="row ml-0 mr-0">
                        <div className="col-md-9 col-lg-12 gym-1 text-center loc-label">
                          <h6>GYM-1</h6>
                        </div>
                      </div>
                      <div className="row ml-0 mr-0">
                        <div className="col-md-1 d-md-block road loc-label">
                          <h6>ROAD</h6>
                        </div>
                        <div className="col-md-9 col-lg-11 p-0 parkingDiv">
                          <div className="container">
                            <div className="text-center mt-5 h3 font-weight-normal">
                              SELECT A PARKING SPOT
                            </div>
                            <div className="row pr-5 pl-5 pt-4 slot-row">
                              {allParkingSlots.map(parkingSpot => {
                                if (parkingSpot.status === "Reserved") {
                                  return (
                                    <div className="col-sm text-center p-0 slot-div reserved">
                                      <h6>Reserved</h6>
                                      <hr className="m-0" />
                                      <h1>{parkingSpot.name}</h1>
                                      <img
                                        src={reservedImage}
                                        alt=""
                                        className="reservedImage"
                                      />
                                      <p>
                                        Reserved to: <br />
                                        <span className="plate-number">
                                          {parkingSpot.reservedTo}
                                        </span>
                                      </p>
                                    </div>
                                  );
                                } else if (parkingSpot.status === "Available") {
                                  return (
                                    <div
                                      className="col-sm text-center p-0 slot-div slot-available-div"
                                      onClick={
                                        user.role === "admin"
                                          ? null
                                          : () =>
                                              this.handleOpenModal(
                                                parkingSpot.name
                                              )
                                      }
                                    >
                                      <h6>Available</h6>
                                      <hr className="m-0" />
                                      <h1>{parkingSpot.name}</h1>
                                    </div>
                                  );
                                } else if (parkingSpot.status === "Occupied") {
                                  return (
                                    <div className="col-sm text-center p-0 slot-div occupied">
                                      <h6>Occupied</h6>
                                      <hr className="m-0" />
                                      <h1>{parkingSpot.name}</h1>
                                      <img
                                        src={occupiedImage}
                                        alt=""
                                        className="occupiedImage"
                                      />
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div className="col-sm text-center p-0 slot-div walk-in-spot">
                                      <h6> </h6>
                                      <hr className="m-0" />
                                      <h1>{parkingSpot.name}</h1>
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  ui: state.ui
});

export default connect(mapStateToProps)(Home);
